export * from './ngx-charts.component';